export enum Permission {
  AdminPanel = 'admin_panel.legacy_permission',
}
